$(function () {
    $('#successFeedbackModal .modal-close').on('click', function () {
        window.location.href = $(this).closest('.modal-dialog').find('.btn.btn-primary').attr('href');
    });
});